import Configuration from "./configuration";

class NotificationService {
  constructor(token, user) {
    this.config = new Configuration(token, user, "api/Notification");
  }

  /**
   * @method getNotifications list of notifications for user
   * @return {Promise} result object notifications
   */
  getNotifications() {
    return this.config.API.get(`GetNotifications`, {
      params: {
        user: this.config.user
      }
    }).then(response => {
      if (response.status !== 200) {
        return this.config.handleResponseError(response);
      }
      return response.data;
    });
  }

  /**
   * @method readNotification discard notification
   * @return {Promise} result object notifications
   */
  readNotification(notificationId) {
    return this.config.API.get(`ReadNotification`, {
      params: {
        notificationId
      }
    }).then(response => {
      if (response.status !== 200) {
        return this.config.handleResponseError(response);
      }
      return response.data;
    });
  }
}

export default NotificationService;
